import {createTypedHooks} from 'easy-peasy';
import {IStore} from './store'; // 👈import the helper

// Provide our model to the helper      👇
const typedHooks = createTypedHooks<IStore>();

// 👇 export the typed hooks
export const useStoreActions = typedHooks.useStoreActions;
export const useStoreDispatch = typedHooks.useStoreDispatch;
export const useStoreState = typedHooks.useStoreState;
